import { PopoverInstance, PopoverWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { UserDefinedPoolModel } from '../types/PoolModel';

export type PoolNamePopoverProps = Readonly<{
  pool: UserDefinedPoolModel;
}>;

export function PoolNamePopover(props: PoolNamePopoverProps) {
  const popoverInstance = React.useRef<PopoverInstance>(null);

  return (
    <PopoverWidget
      testId='pool-name-popover'
      aria-describedby='popoverDescription'
      placement='right'
      popoverContent={<form>
        <p id='popoverDescription'>{Messages.bridgeSiteSettingsPoolId()} {props.pool.id}</p>
      </form>}
      ref={popoverInstance}
      title={Messages.bridgeSiteSettingsPoolId()}
      showTitleBar={false}
      triggerElement={
        <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'pool-name-cell'}>
          {props.pool.displayName}
        </span>
      }
    />
  );
}
